import {
  GetUserMetadataV2CommandInput,
  GetUserMetadataV2CommandOutput,
} from '@amzn/gbsa-orbit-typescript-client';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { userKeys } from 'src/data/api/orbit-service-ts/user/queries/keys';
import { userService } from 'src/data/api/orbit-service-ts/user/userService';

export const useUserMetadataQuery = <TData = GetUserMetadataV2CommandOutput>(
  { programId, userId: userAlias }: Partial<GetUserMetadataV2CommandInput>,
  options?: Omit<
    UseQueryOptions<GetUserMetadataV2CommandOutput, Error, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    ...options,
    queryKey: userKeys.metadata({ userAlias, programId }),
    enabled: !!userAlias && !!programId,
    queryFn: async () => {
      if (!userAlias || !programId) {
        throw new Error('Missing required parameters');
      }
      return await userService.getUserMetadata({
        userId: userAlias,
        programId: programId,
      });
    },
  });
